import React from "react";
import SectionRowLayout, { MainText } from './../../../shared/components/SectionRowLayout';
import ArrowButtonLink from './../../../shared/components/ArrowButtonLink';
import Box from '@material-ui/core/Box';
import Grid from '@material-ui/core/Grid';
import { Typography, withWidth, withStyles } from "@material-ui/core";
import styled from 'styled-components';
import classNames from "classnames";
import DynamicElement from 'shared/components/DynamicElement';
import SectionLineTitle from 'shared/components/SectionLineTitle';
import { LazyLoadImage } from 'react-lazy-load-image-component';

const styles = (theme) => ({

});

const HighlightTypography = styled(Typography)`
  height: 18px;
  font-family: MinionPro-Disp;
  font-size: 20px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.4;
  letter-spacing: normal;
  text-align: left;
  color: #b08f6e;
  margin-bottom: 20px;
`;

const ItemTextTypography = styled(Typography)`
  height: 99px;
  font-family: Lato;
  font-size: 16px;
  text-align: left;
  color: #b6b8bc;
`;

function ContactUs(props) {
  return (
    <div id={props.id} style={{ backgroundColor: "#121416", position: 'relative', display: 'flex' }}>

      <div className="container-fluid lg-p-top lg-p-bottom" style={{ margin: 'auto' }}>


        <SectionRowLayout
          swapSides
          bigImage={'5ff65cf92a34245c31b64e03'}
          bigImageMaxWidth={364}
          infoSideStyle={{ paddingLeft: 0, paddingRight: 0, paddingTop: 50, paddingBottom: 20 }}
          smallTitle={
            <DynamicElement id="5ff65a402a34245c31b64dfa">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          }
          bigTitle={
            <Box mt={4}>
              <DynamicElement id="5ff65a772a34245c31b64dfb">
                {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
              </DynamicElement>
            </Box>
          }
          description={<Grid container>
            <Grid xs={4} item>
              <HighlightTypography variant="h5">
                <DynamicElement id="5ff65ac52a34245c31b64dfc">
                  {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
              </HighlightTypography>
              <ItemTextTypography>
                <DynamicElement id="5ff65aea2a34245c31b64dfd">
                  {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
              </ItemTextTypography>
            </Grid>
            <Grid xs={3} item>
              <HighlightTypography variant="h5">
                <DynamicElement id="5ff65b722a34245c31b64dfe">
                  {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
              </HighlightTypography>
              <ItemTextTypography>
                <DynamicElement id="5ff65bc32a34245c31b64dff">
                  {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
              </ItemTextTypography>
            </Grid>
            <Grid xs={5} item>
              <HighlightTypography variant="h5">
                <DynamicElement id="5ff65be02a34245c31b64e00">
                  {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
              </HighlightTypography>
              <ItemTextTypography>
                <DynamicElement id="5ff65c1a2a34245c31b64e01">
                  {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
                </DynamicElement>
              </ItemTextTypography>
            </Grid>
          </Grid>}
        />

        <ArrowButtonLink to={'/contact-us'} label={'Contact Us'} ml={-1} />
      </div>

      <DynamicElement id="5ff65c8b2a34245c31b64e02" style={{ position: 'absolute', bottom: 140, right: 90 }}>
        {({ value }) => (
          <LazyLoadImage src={value} style={{
            width: 210,
            height: 153,
            objectFit: 'cover',
          }} />
        )}
      </DynamicElement>


      <br />
    </div>
  );
}


const MobileWrapper = styled.div`
  width: 100%;
  position: relative;
  background-color: #121416;

  .SectionLineTitle{
    margin-top: 100px;
    width: 255px;

    font-family: MinionPro;
    font-size: 20px;
    font-weight: normal;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.45;
    letter-spacing: normal;
  }

  .MainText{
    font-size: 55px;
    line-height: 1;
    padding-top: 20px;
    text-align: center;
    margin-bottom: 30px;
    color: #313438;
  }
  
  .bigImage{
    position: absolute;
    top: 380px;
    right: 24px;
    width: 65%;
    height: auto;

    img{
        width: 100%;
    }
  }

  .smallImage{
    position: absolute;
    top: 410px;
    left: 24px;
    width: 28%;
    height: auto;

    img{
        width: 100%;
    }
  }

  small, h5, p{
    text-align: center !important;
  }

  .ItemTextTypography{
    height: auto;
    margin-bottom: 40px;
  }

  button{
    margin-left: auto;
    margin-right: auto;
    display: flex;
    margin-top: -14px;
    margin-bottom: 14px;
  }
`;

const SectionWrapper = (props) => {
  if (props.width === 'xs') {
    return <MobileWrapper>

      <div style={{ textAlign: 'right' }}>
        <SectionLineTitle className="SectionLineTitle">
          <DynamicElement id="5ff65a402a34245c31b64dfa">
            {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
          </DynamicElement>
        </SectionLineTitle>
      </div>

      <MainText className="MainText">
        <DynamicElement id="5ff65a772a34245c31b64dfb">
          {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
        </DynamicElement>
      </MainText>

      {/* <div className="bigImage">
        <DynamicElement id="5ff6575f2a34245c31b64df6">
          {({ value }) => <LazyLoadImage alt="" src={value} />}
        </DynamicElement>
      </div>

      <div className="smallImage">
        <DynamicElement id="5ff7a029abbee9b8a71decdd">
          {({ value }) => <LazyLoadImage src={value} />}
        </DynamicElement>
      </div> */}

      <Grid container direction="column" alignContent="center">
        <Grid xs={12} item style={{ textAlign: "center" }}>
          <HighlightTypography variant="h5">
            <DynamicElement id="5ff65ac52a34245c31b64dfc">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          </HighlightTypography>
          <ItemTextTypography className="ItemTextTypography">
            <DynamicElement id="5ff65aea2a34245c31b64dfd">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          </ItemTextTypography>
        </Grid>
        <Grid xs={12} item style={{ textAlign: "center" }}>
          <HighlightTypography variant="h5">
            <DynamicElement id="5ff65b722a34245c31b64dfe">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          </HighlightTypography>
          <ItemTextTypography className="ItemTextTypography">
            <DynamicElement id="5ff65bc32a34245c31b64dff">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          </ItemTextTypography>
        </Grid>
        <Grid xs={12} item style={{ textAlign: "center" }}>
          <HighlightTypography variant="h5">
            <DynamicElement id="5ff65be02a34245c31b64e00">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          </HighlightTypography>
          <ItemTextTypography className="ItemTextTypography">
            <DynamicElement id="5ff65c1a2a34245c31b64e01">
              {({ value }) => <span dangerouslySetInnerHTML={{ __html: value }} />}
            </DynamicElement>
          </ItemTextTypography>
        </Grid>
      </Grid>

      <ArrowButtonLink to={'/contact-us'} label={'Contact Us'} style={{
        marginTop: 0,
        display: 'block',
        paddingBottom: 60,
      }} />

      <DynamicElement id="5ff65cf92a34245c31b64e03" /* style={{ position: 'absolute', bottom: 140, right: 90 }} */ >
        {({ value }) => (
          <LazyLoadImage src={value} style={{
            width: '85%',
            height: 'auto',
            objectFit: 'cover',
            padding: 24,
            marginBottom: 100,
          }} />
        )}
      </DynamicElement>

      <DynamicElement id="5ff65c8b2a34245c31b64e02" style={{ position: 'absolute', bottom: 80, right: 0 }}>
        {({ value }) => (
          <LazyLoadImage src={value} style={{
            width: 137,
            height: 'auto',
            objectFit: 'cover',
          }} />
        )}
      </DynamicElement>



    </MobileWrapper>;
  } else {
    return <ContactUs {...props} />
  }
}


export default React.memo(withWidth()(withStyles(styles, { withTheme: true })(SectionWrapper)));
